export const LINE_TYPE_SELECT_OPTIONS: ReadonlyArray<{
  readonly value: string;
  readonly label: string;
}> = [
  { value: 'symbols-sls-short-dash-dot-dot', label: '' },
  { value: 'symbols-sls-long-dash-dot-dot', label: '' },
  { value: 'symbols-sls-dash-dot', label: '' },
  { value: 'symbols-sls-dash', label: '' },
  { value: 'symbols-sls-dot', label: '' },
  { value: 'symbols-sls-long-dash-dot', label: '' },
  { value: 'symbols-sls-long-dash', label: '' },
  { value: 'symbols-sls-short-dash-dot', label: '' },
  { value: 'symbols-sls-short-dash', label: '' },
  { value: 'symbols-sls-short-dot', label: '' },
  { value: 'symbols-sls-solid', label: '' },
];

export function lineStyleSlugToSelectValue(lineStyle: string): string {
  const normalized = lineStyle.trim() || 'solid';
  return `symbols-sls-${normalized}`;
}

export function lineStyleSelectValueToSlug(value: string): string {
  return value.replace('symbols-sls-', '') || 'solid';
}
